import { getNumericValue, resolveFallback } from "./formatterUtils";

type FormatPercentageOptions = {
  precision?: number;
  fallback?: string;
  showFallback?: boolean;
};

export const formatPercentage = (value?: number | string | null, options: FormatPercentageOptions = {}): string => {
  const { precision = 2, fallback = "--", showFallback = true } = options;

  const numericValue = getNumericValue(value);
  if (numericValue === null) {
    return resolveFallback({ fallback, showFallback });
  }

  return numericValue > 0 ? `${numericValue.toFixed(precision)}%` : "0%";
};
